import createEl from './createEl';

let tooltip;

let screenPadding = 8;

function create (position, text, timeout = 1500) {
  if (tooltip.current) {
    tooltip.current.destroy();
  }
  const el = createEl('div', ['gmf-tooltip', 'gmf-hidden'], document.body);
  el.innerText = text;
  el.style.left = position.x + 'px';
  el.style.top = position.y + 'px';

  setTimeout(() => {
    el.classList.remove('gmf-hidden');

    const rect = el.getBoundingClientRect();

    if (rect.x < screenPadding) {
      el.style.left = (position.x - rect.x + screenPadding) + 'px';
    }
    if (rect.x + rect.width > document.body.clientWidth - screenPadding) {
      const offset = (document.body.clientWidth - screenPadding) - (rect.x + rect.width);
      el.style.left = (position.x + offset) + 'px';
    }
  }, 0);

  const destroy = function () {
    el.classList.add('gmf-hidden');

    el.ontransitionend = () => {
      if (el.parentElement) {
        el.parentElement.removeChild(el);
      }
    };

    if (tooltip.current && tooltip.current.el === el) {
      tooltip.current = null;
    }
    document.body.removeEventListener('mousedown', destroy);
  };

  document.body.addEventListener('mousedown', destroy);

  setTimeout(destroy, timeout);

  tooltip.current = {
    el,
    destroy,
  };
}

tooltip = {
  current: null,
  create,
};

window.tooltip = tooltip;

export default tooltip;
